import React, {useEffect, useState} from "react"
import {Route, Routes} from 'react-router-dom'
import {Box, createTheme, LoadingOverlay, MantineProvider} from "@mantine/core"
import DetailsForm from "./components/DetailsForm"
import Navigation from "./components/Navigation"
import NotFound from "./components/NotFound"
import Signing from "./components/Signing"
import Results from "./components/Results"
import SigninOverlay from "./components/SigninOverlay"
import {classNames} from "./utils/helpers"
import '@mantine/core/styles.css'
import '@mantine/charts/styles.css'
import "./App.css"
import useAnalytics from "./utils/useAnalytics"
import {ContentProvider, useContentContext} from "./utils/ContentProvider"
import Footer from "./components/Footer";
import InsuranceAgent from "./components/InsuranceAgent";
import RemoteSales from "./components/RemoteSales";
import Privacy from "./components/Privacy";

const theme = createTheme({})

export default function App() {
  const contentContext = useContentContext()
  const {translations} = useContentContext()
  const hideOverlay: boolean = true
          // (location.hostname.indexOf("vakuutustenvertailu") > -1) ||
          // (location.hostname.indexOf("effortia") > -1) ||
          // (location.hostname.indexOf("vakuutuslaskuri") > -1)
  const [overlayVisible, setOverlayVisible] = useState<boolean>(hideOverlay ? false : true)
  const [insuranceType, setInsuranceType] = useState<string>("")

  useAnalytics()

  useEffect(() => {
    const rootElement = document.querySelector("#root")

    if (rootElement && window && window.parent) {
      const resizeObserver = new ResizeObserver(() => {
        window.parent.postMessage(
          {height: Math.ceil(Math.max(rootElement.clientHeight, rootElement.scrollHeight))},
          '*'
        )
      })

      resizeObserver.observe(rootElement)

      return () => {
        resizeObserver.disconnect()
      }
    }
  }, [])

  return (
    <MantineProvider theme={theme}>
      <ContentProvider>
        <Box className={classNames(
          overlayVisible ? 'fixed' : '',
          'h-full w-full'
        )}>
          <LoadingOverlay
            visible={overlayVisible}
            zIndex={1000}
            overlayProps={{radius: 'sm', blur: 5}}
            loaderProps={{children: <SigninOverlay handleSignin={() => setOverlayVisible(false)}/>}}/>
          <Navigation/>
          <article>
            <Routes>
              <Route path="/" element={<Main/>}/>
              <Route path="/form/:insuranceType" element={<DetailsForm setInsuranceType={setInsuranceType}/>
              }/>
              <Route path="/signing" element={<Signing/>}/>
              <Route path="/results" element={<Results company={insuranceType}/>}/>
              <Route path="/insuranceAgent" element={<InsuranceAgent/>}/>
              <Route path="/remoteSales" element={<RemoteSales/>}/>
              <Route path="/privacy" element={<Privacy/>}/>
              <Route path="*" element={<NotFound/>}/>
            </Routes>
          </article>
          <Footer/>
        </Box>
      </ContentProvider>
    </MantineProvider>
  )
}

function Main() {
  return (
    <div></div>
  )
}
